import React from 'react';
import { Box, Typography, useTheme, useMediaQuery } from '@mui/material';
import NewsPreview from '../pages/NewsPreview';
import TrendsPreview from './TrendsPreview';
import ChartsPreview from './ChartsPreview';
import EconomicCalendarPreview from './EconomicCalendarPreview';

const OnsaMarket = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box sx={{ px: { xs: 1, sm: 2 }, py: 2 }}>
      {isMobile && (
        <Typography
          sx={{
            fontFamily: 'Poppins, sans-serif',
            fontWeight: 600,
            fontSize: 20,
            lineHeight: '24px',
            color: '#1C1C1C',
            mb: 2,
          }}
        >
          ONSA Market
        </Typography>
      )}

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: '1fr',
            md: 'repeat(3, minmax(0, 1fr))',
          },
          gap: { xs: 2, sm: 3, md: 4 },
          alignItems: 'start',
          maxWidth: 1600,
          mx: 'auto',
        }}
      >
        {/* NEWS */}
        <Box sx={{ minWidth: 0 }}>
          <NewsPreview
            limit={5}
            spacing={{ xs: 1, sm: 1 }}
            offsetTop
          />
        </Box>

        {/* TRENDS */}
        <Box sx={{ minWidth: 0 }}>
          <TrendsPreview
            layout="column"
            isOnsaMarket
            cardSize="lg"
          />
        </Box>

        {/* CHARTS */}
        <Box sx={{ minWidth: 0, pb: { xs: 10 } }}>
          <ChartsPreview />
        </Box>
      </Box>

      <Box
        sx={{
          mt: { xs: 4, md: 6 },
          maxWidth: 1600,
          mx: 'auto',
        }}
      >
        <EconomicCalendarPreview limit={5} />
      </Box>
    </Box>
  );
};

export default OnsaMarket;
